/* global Sys, Core, Resources */
Sys.ns("Core.Slots");

/**
 * The bonus program widget model.
 *
 * @class Core.Slots.BonusProgramWidgetModel
 * @extends Core.Model
 */
Core.Slots.BonusProgramWidgetModel = {
    constructor: function() {
        Core.Slots.BonusProgramWidgetModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupData: function() {
        var response = Resources.readData("gameServerInitResponse") || {};

        this.storeData("widgetUrl", "../../");
        this.storeData("slowServerRequestTimeLimit", 5000);
        this.setBonusProgramData(response);
    },

    /**
     * Sets the data connected to bonus program.
     *
     * @protected
     * @param {Object} response Response data.
     * @returns {void}
     */
    setBonusProgramData: function(response) {
        this.storeData("bonusProgramWidgetEnabled", Boolean(response.freeRoundWidgetEnabled));
        this.storeData("bonusProgramWidgetGameId", response.freeRoundWidgetGameId);
        this.storeData("bonusProgramWidgetSections", response.freeRoundWidgetSections);
        this.storeData("nextAction", response.nextaction);
    },

    /**
     * Returns bonus program widget status.
     *
     * @protected
     * @returns {boolean} Whether it is enabled or not.
     */
    bonusProgramWidgetEnabled: function() {
        return Boolean(this.readData("bonusProgramWidgetEnabled"));
    }
};

Core.Slots.BonusProgramWidgetModel = Sys.extend(Core.Model, Core.Slots.BonusProgramWidgetModel, "Core.Slots.BonusProgramWidgetModel");
